import React from 'react'
import GalleryItem from './GalleryItem'

const GalleryScreen = ({
  items = [],
  onItemClick = id => {},
  onVoteClick = () => {},
  zeroVotesCopy = '',
  galleryWidth = 4,
  hasVoting = true,
}) => {
  let isLoading = items && items.length === 0 ? true : false
  return (
    <>
      <div className="step-screen gallery-screen">
        <div className={`gallery-list ${isLoading ? 'is--loading' : 'off'}`}>
          {items.length > 0 &&
            items.map((item, i) => {
              return (
                <GalleryItem
                  hasVoting={hasVoting}
                  item={item}
                  key={i}
                  id={item.id}
                  title={item.title}
                  caption={item.caption}
                  name={item.firstName}
                  thumbnail={`${item.uploadFile}`}
                  uploadFile={item.uploadFile}
                  votes={item.voteCount}
                  handleItemClick={onItemClick}
                  onVoteClick={onVoteClick}
                  zeroVotesCopy={zeroVotesCopy}
                  galleryWidth={galleryWidth}
                />
              )
            })}
        </div>
      </div>
    </>
  )
}
export default GalleryScreen
